import React from 'react';
import {gql} from '@apollo/client';
import {useLazyQuery} from '@apollo/client/react';

import {SubEventType} from 'types/App';
import EditTrackForm from './EditTrackForm';
import {TrackPoint} from './CompetitorTrackForm';
import {Button} from '@mui/material';
import CreateDialogBody from 'components/forms/CreateDialogBody';
import ButtonDialog from 'components/forms/ButtonDialog';

const GET_LIVE_DEVICES = gql`
  query GetLiveDevices($names: [String!]!, $slug: String, $from: Date, $end: Date) {
    getLiveDevices(names: $names, slug: $slug, from: $from, end: $end) {
      name
      points
    }
  }
`;

const ImportTrack = (props: ImportTrackProps) => {
  const {
    subEvent,
    callback,
    competitor: {color, device}
  } = props;

  const [track, setTrack] = React.useState<TrackPoint[]>([]);

  const [getLiveDevicesData] = useLazyQuery<{getLiveDevices: {name: string; points: number[][]}[]}>(GET_LIVE_DEVICES);

  const onButtonClick = async (callback: () => void) => {
    const result = await getLiveDevicesData({
      variables: {
        from: new Date(subEvent.event.startDate || '').getTime(),
        end: new Date(subEvent.event.endDate || '').getTime(),
        slug: subEvent.event.slug,
        names: [device.name]
      }
    });
    const getLiveDevices = result.data?.getLiveDevices;
    if (!getLiveDevices?.length) {
      return;
    }
    const startTime = new Date(subEvent.event.startDate || '').getTime();
    const data: TrackPoint[] = getLiveDevices[0].points.map((p: number[]) => {
      return {
        lng: p[2],
        lat: p[1],
        time: p[0] * 1000 + startTime,
        alt: p[3]
      };
    });
    data.sort((a, b) => a.time - b.time);
    setTrack(data);
    callback();
  };

  return (
    <ButtonDialog
      buttonLabel="Get Track from GPS"
      onClick={onButtonClick}
      primaryButton={
        <Button type="submit" form="create_CompetitorTrack" variant="contained">
          Create
        </Button>
      }
    >
      <CreateDialogBody onSuccess={callback}>
        <EditTrackForm subEvent={subEvent} data={track} color={color} />
      </CreateDialogBody>
    </ButtonDialog>
  );
};

export default ImportTrack;

type ImportTrackProps = {
  subEvent: SubEventType;
  competitor: {
    color: string;
    device: {
      name: string;
    };
  };
  callback?: () => void;
};
